module.exports = __webpack_public_path__ + "img/suv.be5cb70e.svg";